import { z } from 'zod'

// Spec PWA-022 D-08 — qual provedor de cartao o aparelho usa e o AccessToken do Silent Order Post da Braspag (o aparelho
// manda o cartao direto para a Braspag com ele; o servidor nunca ve numero nem CVV).

export const PAYMENT_PROVIDERS = ['simulated', 'braspag', 'off'] as const
export const BRASPAG_ENVIRONMENTS = ['sandbox', 'production'] as const

export const paymentsConfigSchema = z.object({
    provider: z.enum(PAYMENT_PROVIDERS),
    /** So com provider = braspag: escolhe a URL do SOP no aparelho. */
    environment: z.enum(BRASPAG_ENVIRONMENTS).optional(),
    /** C#2: 'sop' = o aparelho pede o VerifyCard junto com o token. */
    verify: z.enum(['sop', 'auth']).optional(),
    /** Revisao 2026-10-20: so no sandbox — o aparelho mostra os cartoes de teste da Braspag em vez do formulario. */
    testCards: z.boolean().optional(),
}).strict()
export type PaymentsConfig = z.infer<typeof paymentsConfigSchema>

export const sopTokenSchema = z.object({
    accessToken: z.string().min(16).max(512),
    environment: z.enum(BRASPAG_ENVIRONMENTS),
    expiresAt: z.string().datetime(),
}).strict()
export type SopToken = z.infer<typeof sopTokenSchema>
